import React from "react";
import usePageMetadata from "../hooks/usePageMetadata";

const CookiesPolicy = () => {
  usePageMetadata({
    title: "TOLSOL | Pol\u00edtica de cookies",
    description:
      "Descubre c\u00f3mo TOLSOL utiliza cookies para mejorar tu experiencia y obtener anal\u00edticas del sitio web.",
  });

  return (
    <main className="bg-[#F2F2F2] pt-32 pb-16 text-[#0A192F]">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-4xl font-bold mb-4">Pol\u00edtica de cookies</h1>
        <p className="text-[#0A192F]/70 leading-relaxed">
          Estamos preparando esta secci\u00f3n con informaci\u00f3n detallada sobre el uso de cookies en nuestro sitio
          web. Si necesitas esta informaci\u00f3n con urgencia, ponte en contacto con nosotros en{" "}
          <a href="mailto:info@tolsol.es" className="text-[#134b8a] underline">
            info@tolsol.es
          </a>
          .
        </p>
      </div>
    </main>
  );
};

export default CookiesPolicy;
